import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeExperiencesHandlers from "../../../context/resume/hooks/resume-experiences-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddExperienceAction(
    {
        parentOrder
    }
) {
    const { translations } = useContext( TranslationContext );
    const { handleAddAction } = useResumeExperiencesHandlers();

    return (
        <button className="btn_primary" onClick={ () => handleAddAction( parentOrder ) }>
            <MDBIcon fas icon="plus-circle" title={ translations.experiencesSection.addActionLabel } color='light'
                     size='sm'/>
            <span className='ms-1'>{ translations.experiencesSection.addActionLabel }</span>
        </button>
    )
}
